// @ts-nocheck
import React from 'react'
import Lottie from 'react-lottie'
import { useDispatch, useSelector } from 'react-redux'
// @ts-ignore
import { Outlet } from 'react-router-dom'

// material-ui
import { styled, useTheme, Theme } from '@mui/material/styles'
import loadingAnimation from 'src/assets/lottie/data-loader.json'
import { AppBar, Box, CssBaseline, useMediaQuery, Grid, Button, Typography, Divider } from '@mui/material'

// project imports
import Breadcrumbs from 'src/ui-component/extended/Breadcrumbs'
import Header from './Header'
import Sidebar from './Sidebar'
import navigation from 'src/menu-items'
import { drawerWidth } from 'src/store/constant'
import { SET_MENU } from 'src/store/actions'
import { DefaultRootStateProps } from 'src/types'
import { useEffect } from 'react'
import useSpace from 'src/hooks/useSpace'

// assets
import SpaceSelection from 'src/layout/MainLayout/Header/SpaceSelection'
import { useLoading } from 'src/contexts/LoadingContext'
import { adminTokens } from 'src/views/common/adminTokens'
import PhosphorIcon from 'src/views/common/PhosphorIcon'
import { PrimaryButton } from 'src/views/common/AdminUiKit'
import useConfig from 'src/hooks/useConfig'
import { useNavigate } from 'react-router-dom'
import { CONFIG } from 'src/store/constant'
import { usePageAction } from 'src/contexts/PageActionContext'

interface MainStyleProps {
    theme: Theme
    open: boolean
}

// styles
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }: MainStyleProps) => ({
    ...theme.typography.mainContent,
    ...(!open && {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        // [theme.breakpoints.up('md')]: {
        //     marginLeft: -(drawerWidth - 20),
        //     width: `calc(100% - ${drawerWidth}px)`
        // },
        // [theme.breakpoints.down('md')]: {
        //     marginLeft: '20px',
        //     width: `calc(100% - ${drawerWidth}px)`,
        //     padding: '16px'
        // },
        // [theme.breakpoints.down('sm')]: {
        //     marginLeft: '10px',
        //     width: `calc(100% - ${drawerWidth}px)`,
        //     padding: '16px',
        //     marginRight: '10px'
        // }
    }),
    ...(open && {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        // width: `calc(100% - ${drawerWidth}px)`,
        // [theme.breakpoints.down('md')]: {
        //     marginLeft: '20px'
        // },
        // [theme.breakpoints.down('sm')]: {
        //     marginLeft: '10px'
        // }
    })
}))

// ==============================|| MAIN LAYOUT ||============================== //

function Footer() {
    const footerStyle = {
        color: 'black',
        padding: '10px 20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    }

    const sectionStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '15px',
    }

    const titleStyle = {
        color: 'black',
        marginRight: '10px'
    }

    const linkStyle = {
        color: 'gray',
        textDecoration: 'none',
        marginRight: '10px',
    }

    return (
        <footer style={footerStyle}>

            <div style={sectionStyle}>
                <h4 style={titleStyle}>Resources:</h4>
                <a href='https://hyzebra.com/community' style={linkStyle}>Community</a>
                <a href='https://hyzebra.com/documentation' style={linkStyle}>Knowledge Base</a>
                <a href='https://hyzebra.com/support' style={linkStyle}>Support</a>
                <a href='https://hyzebra.com/affiliate' style={linkStyle}>Affiliate</a>
            </div>
        </footer>
    )
}

const MainLayout = () => {
    const spacing = 1.5
    const theme = useTheme()
    const [space] = useSpace()
    const { isLoading } = useLoading()
    const { config, setConfig }: any = useConfig()
    const { action } = usePageAction()
    const navigate = useNavigate()
    const matchDownMd = useMediaQuery(theme.breakpoints.down('lg'))

    useEffect(() => {
        document.title = `${space?.name ? `${space.name} -` : ''} hyzebra`
    }, [space])

    // Handle left drawer
    const leftDrawerOpened: boolean = useSelector((state: DefaultRootStateProps) => state.customization.opened)
    const dispatch = useDispatch()
    const handleLeftDrawerToggle = () => {
        dispatch({ type: SET_MENU, opened: !leftDrawerOpened })
    }

    const defaultOptionsLoader = {
        loop: true,
        autoplay: true,
        animationData: loadingAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    }

    React.useEffect(() => {
        dispatch({ type: SET_MENU, opened: !matchDownMd })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [matchDownMd])

    return (
        <>
            <CssBaseline />

            {/* header */}
            <Grid
                container
                direction='row'
                sx={{ height: '100vh', width: '100vw', margin: 0, padding: spacing, paddingBottom: 0, bgcolor: '#fafafa' }}
            >
                {/* This Grid item will represent the header and have a fixed height */}
                <Grid item container component='header'
                    xs={12}
                    sx={{
                        margin: 0,
                        padding: 0,
                        height: `${adminTokens.topbarH}px`,
                        paddingX: spacing,
                        bgcolor: adminTokens.surface,
                        borderRadius: adminTokens.radiusLg,
                        alignItems: 'center',
                        marginBottom: spacing,
                        border: adminTokens.borderMd,
                        boxShadow: adminTokens.shadowCard,
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',
                    }}
                >

                    {/* Left: back-to-main (space-settings only) + space switcher */}
                    <Grid item xs sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
                        {config === 'Active' && space?.id ? (
                            <Box
                                component="button"
                                type="button"
                                onClick={() => {
                                    window.localStorage.removeItem(CONFIG)
                                    setConfig(null)
                                    navigate('/page/list')
                                }}
                                sx={{
                                    display: 'flex', alignItems: 'center', height: 40, padding: '0 12px',
                                    borderRadius: adminTokens.radiusMd, border: 'none', cursor: 'pointer',
                                    background: 'none', color: adminTokens.navy800,
                                    fontFamily: adminTokens.fontSans, fontSize: adminTokens.textBase, fontWeight: 600,
                                    flexShrink: 0, whiteSpace: 'nowrap', overflow: 'hidden',
                                    transition: 'background .15s ease',
                                    '&:hover': { background: adminTokens.gray100 },
                                    '&:hover .nav-back-icon': { transform: 'translateX(-2px)' },
                                    '&:hover .nav-back-label': { maxWidth: 140, opacity: 1, ml: 1 },
                                }}
                            >
                                <Box className="nav-back-icon" sx={{ display: 'inline-flex', flexShrink: 0, transition: 'transform .2s ease' }}>
                                    <PhosphorIcon name="arrow-left" size={16} color={adminTokens.navy800} />
                                </Box>
                                <Box
                                    component="span"
                                    className="nav-back-label"
                                    sx={{
                                        display: 'inline-block', maxWidth: 0, opacity: 0, ml: 0, whiteSpace: 'nowrap', overflow: 'hidden',
                                        transition: 'max-width .25s ease, opacity .2s ease .05s, margin-left .25s ease',
                                    }}
                                >
                                    Back to main
                                </Box>
                            </Box>
                        ) : null}
                        <SpaceSelection />
                    </Grid>

                    {/* Logo in the Middle */}
                    <Grid item sx={{ flexShrink: 0 }}>
                        <Box
                            component="a"
                            href='/'
                            sx={{
                                fontFamily: adminTokens.fontSans, fontSize: 15, fontWeight: 800, letterSpacing: '-.02em',
                                color: adminTokens.navy900, textDecoration: 'none',
                            }}
                        >
                            hy<Box component="span" sx={{ color: adminTokens.gray400, fontWeight: 600 }}>zebra</Box>
                        </Box>
                    </Grid>

                    {/* Right: help + current page's primary action */}
                    <Grid item xs sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1 }}>
                        {action && (
                            <PrimaryButton onClick={action.onClick} disabled={action.disabled}>
                                {action.children}
                            </PrimaryButton>
                        )}
                        <Box
                            component="button"
                            type="button"
                            aria-label="Help & resources"
                            title="Community · Knowledge Base · Support · Affiliate"
                            onClick={() => window.open('https://hyzebra.com/support')}
                            sx={{
                                width: 36, height: 36, borderRadius: adminTokens.radiusMd, border: 'none', background: 'none',
                                display: 'inline-flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
                                color: adminTokens.gray500,
                                '&:hover': { background: adminTokens.gray100, color: adminTokens.navy800 },
                            }}
                        >
                            <PhosphorIcon name="question" size={18} color="currentColor" />
                        </Box>
                    </Grid>
                </Grid>

                {/* This Grid item will take up the rest of the vertical space */}
                <Grid item container xs={12} sx={{ flexGrow: 1, height: `calc(100vh - ${adminTokens.topbarH}px - ${1 * spacing}rem)` }}>
                    {/* drawer */}
                    <Grid item sx={{ height: '100%', paddingBottom: spacing }}>
                        <Box sx={{
                            height: '100%',
                            overflowY: 'auto',
                            border: adminTokens.borderMd,
                            bgcolor: adminTokens.surface,
                            borderRadius: adminTokens.radiusLg,
                            boxShadow: adminTokens.shadowCard,
                        }}>
                            <Sidebar drawerOpen={leftDrawerOpened} drawerToggle={handleLeftDrawerToggle} />
                        </Box>
                    </Grid>
                    {/* <Grid item>
                        <Divider orientation='vertical' />
                    </Grid> */}
                    <Grid item container xs
                        sx={{
                            overflowY: 'auto',
                            marginLeft: spacing,
                            // flexGrow: 1,
                            height: '100%',
                            paddingBottom: spacing
                            // border: '1px solid #eaeaea',
                            // bgcolor: '#ffffff',
                            // borderRadius: '6px'
                        }}
                    >

                        {/* data loading animation */}
                        {isLoading && <Grid item xs={12} sx={{
                            zIndex: 10,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: `calc(100vh - ${adminTokens.topbarH}px - ${2 * spacing}rem - 270px)`
                        }}>
                            <Lottie options={defaultOptionsLoader} height={160} width={160} />
                        </Grid>}
                        <Grid item xs={12} sx={{
                            // marginLeft: spacing,
                            pointerEvents: isLoading ? 'none' : 'auto',
                            visibility: isLoading ? 'hidden' : 'visible',
                            height: isLoading ? 0 : 'auto',  // this ensures the Main doesn't take space
                            overflow: isLoading ? 'hidden' : 'visible'
                        }}>
                            <Main theme={theme} open={leftDrawerOpened} sx={{ margin: 0, padding: 0 }}>
                                <Outlet />
                            </Main>
                        </Grid>

                        {/* <Grid item xs={12} sx={{ marginTop: spacing }}>
                            <Divider sx={{ color: 'red' }} />
                        </Grid> */}
                        <Grid item xs={12} alignSelf='flex-end' sx={{
                            marginTop: spacing,
                            height: '50px',
                            display: 'flex',
                            alignItems: 'center',
                            border: adminTokens.borderMd,
                            bgcolor: adminTokens.surface,
                            borderRadius: adminTokens.radiusLg,
                            boxShadow: adminTokens.shadowCard,
                        }}>
                            <Footer />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default MainLayout
